
import { SERVICES_API } from "../config/api";

class FormsService {

    // Insert Client Partial Registration Data ====================================================================================================
    /**
     * Insert Client Partial Registration Data
     * @type {object}
     * @property {string} email
     * @property {string} documentId
     * @property {boolean} selected_product
     * @property {boolean} is_onboarding
     * @property {boolean} checked_list
     * @property {number} module - form module number
     * @property {number} step - form step number
     * @property {object} data - object with the form values
     * @returns {object} - True or false if the partial data was inserted
    */
    insertarClienteDataParcial(data) {
        const url = `/insertarClienteDataParcial`;

        return SERVICES_API.post(url, data);
    }

    
    // Consult Client Partial Registration Data ====================================================================================================
    /**
     * Consult Client Partial Registration Data
     * @type {object}
     * @property {string} email
     * @returns {object} - The client partial registration data
    */
    clienteDataParcial(data) {
        const url = `/clienteDataParcial`;

        return SERVICES_API.post(url, data);
    }

    
    // Consult Existing Client Data ====================================================================================================
    /**
     * Consult Existing Client Data
     * @type {object}
     * @property {string} email
     * @returns {object} - The existing client data
    */
    clienteExistente(data) {
        const url = `/clienteExistente`;

        return SERVICES_API.post(url, data);
    }
    
}

export default new FormsService();